import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Tabs from "@mui/material/Tabs";
import { useState } from "react";

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const KategoriDeviceDialog = ({
  dataKategoriDevice,
  openKategoriDevice,
  handleCloseKategoriDevice,
  onSelect,
}) => {
 
  return (
    <Dialog
      fullScreen
      open={openKategoriDevice}
      onClose={handleCloseKategoriDevice}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
        <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseKategoriDevice}
            aria-label="close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Pilih Kategori Device
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Tabs
          variant="scrollable"
          scrollButtons="auto"
          sx={{ mb: 2, bgcolor: "#ffffff", borderRadius: 2 }}
        >
           <Tab label="Kategori Device" value="Kategori Device" key="manual-tab" />
        </Tabs>

        {dataKategoriDevice.map((device, index) => (
        <ListItem
          key={index}
          onClick={() => onSelect(device)}
          sx={{
            bgcolor: "#fff",
            borderRadius: 2,
            mb: 1,
            boxShadow: 1,
            cursor: "pointer",
            px: 2,
            py: 1.5,
          }}
        >
          <ListItemText
            primary={
              <Typography variant="body2" fontWeight="bold" color="text.primary">
                {device.name}
              </Typography>
            }
          />
        </ListItem>
      ))}
       
      </Box>
    </Dialog>
  );
};

export default KategoriDeviceDialog;
